import { CreateCustomerDTO } from '../DTO/CreateCustomerDTO';
import { CustomerService } from '../services/CustomerService';
import { container } from 'tsyringe';
import { Customer } from '@/core/customer/models/Customer';

export const createCustomerUseCase = async (guid: string, customer: CreateCustomerDTO): Promise<Customer> => {
  const customerService = container.resolve<CustomerService>('CustomerService');
  return await customerService.createCustomer(guid, customer);
};
